module.exports = __webpack_public_path__ + "img/game1.2.4d0b44fc.png";